export const FETCH_DAILY_POWER_BI_REPORT_REQUEST = 'FETCH_DAILY_POWER_BI_REPORT_REQUEST';
export const FETCH_DAILY_POWER_BI_REPORT_SUCCESS = 'FETCH_DAILY_POWER_BI_REPORT_SUCCESS';
export const FETCH_DAILY_POWER_BI_REPORT_FAILURE = 'FETCH_DAILY_POWER_BI_REPORT_FAILURE';

export const FETCH_DAILY_REPORT_LAST_REFRESHED_REQUEST = 'FETCH_DAILY_REPORT_LAST_REFRESHED_REQUEST';
export const FETCH_DAILY_REPORT_LAST_REFRESHED_SUCCESS = 'FETCH_DAILY_REPORT_LAST_REFRESHED_SUCCESS';
export const FETCH_DAILY_REPORT_LAST_REFRESHED_FAILURE = 'FETCH_DAILY_REPORT_LAST_REFRESHED_FAILURE';
